import React, { useState } from 'react'
import { useHistory, useLocation, Redirect } from 'react-router-dom'
import { Flex, Box } from 'reflexbox/styled-components'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'

import Card from 'components/Card'
import Button from 'components/Button'
import Loader from 'components/Loader'
import { TextField } from 'components/Form/Fields'
import { SemiTitle } from 'components/Typography'
import PublicPageWrapper from 'components/PublicPagesWrapper'

import logo from 'images/guigo_black.svg'

import { FormContainer } from './styles'
import theme from 'styles/theme'

import { redefinePassword } from 'services/users'

Yup.setLocale({
  mixed: {
    required: 'Campo obrigatório',
  },
})

const passwordValidation = Yup.object().shape({
  password: Yup.string().required(),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('password')], 'As senhas devem ser iguais')
    .required(),
})

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

const NewPassword = () => {
  const history = useHistory()
  const query = useQuery()

  const [isSubmiting, setIsSubmiting] = useState(false)

  const handleSubmit = async ({ password }) => {
    try {
      setIsSubmiting(true)

      const token = query.get('token')

      await redefinePassword({ token, password })

      toast.success('Senha alterada com sucesso!')

      setIsSubmiting(false)

      history.push('/login')
    } catch (e) {
      console.log(e)
      toast.error('Não foi possivel alterar sua senha.')
      setIsSubmiting(false)
    }
  }

  if (!query.get('token')) {
    return <Redirect to='login' />
  }

  return (
    <PublicPageWrapper>
      <Card maxWidth='614px' bg={theme.colors.white} p={32}>
        <Flex flexDirection='column' alignItems='center' justifyContent='center' mb={24}>
          <Box mb={32}>
            <img src={logo} />
          </Box>
          <Box mb={32}>
            <SemiTitle color={theme.colors.turquoises.T300} as='h3'>
              Defina uma nova senha
            </SemiTitle>
          </Box>
          <Formik
            initialValues={{
              confirm_password: '',
              password: '',
            }}
            validationSchema={passwordValidation}
            onSubmit={handleSubmit}
          >
            <FormContainer>
              <TextField name='password' type='password' label='Senha' placeholder='Senha' mb={32} />
              <TextField
                name='confirm_password'
                type='password'
                label='Confirmar senha'
                placeholder='Confirmar senha'
                mb={48}
              />
              <Button size='auto' type='submit' disabled={isSubmiting}>
                {isSubmiting ? <Loader /> : 'Definir nova senha'}
              </Button>
            </FormContainer>
          </Formik>
        </Flex>
      </Card>
    </PublicPageWrapper>
  )
}

export default NewPassword
